import React, { useCallback, useEffect, useState } from "react";
import { t } from "i18next";
import { Button, Input } from "components";
// import Phoneinput from "components/Phoneinput";
import { useSelector, useDispatch } from "react-redux";
import {
  CountryCode,
  UpdateAuthData,
  ValidateUserApi,
} from "redux/features/LoginSlice";
import AutoComplete from "components/AutoComplete";
import { useNavigate } from "react-router-dom";
import { domainOptions } from "utils/helper";
import { mailformat } from "utils/Constant";
import { IconButton, InputAdornment } from "@mui/material";
import { ReactComponent as Visibility } from "assert/images/Common/visibility.svg";
import { ReactComponent as VisibilityOff } from "assert/images/Common/visibilityOff.svg";

export default function SettingsOTPVerification({
  StateDetailsFun,
  verifyFun,
  slideChange,
  decrptedPhone,
  decrptedEmail,
  email,
  mobile
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { authData, countryCode } = useSelector((state) => state?.LoginReducer);
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const [isLoading, setIsLoading] = useState(false);
  const [inputChanges, setInputChanges] = useState();
  const [enableSubmit, setEnableSubmit] = useState(null);
  const [changeMobile, setChangeMobile] = useState(false);
  const [newPasswordShow, setNewPasswordShow] = useState(false);
  const [loginDetails, setLoginDetails] = useState({
    type: "email",
    email: "",
    phone: "",
    phcode: "",
    code: "",
    password: "",
    sid: "",
    otpType: "resetPassword",
  });
  const [errMsg, setErrmsg] = useState({
    email: "",
    phone: "",
    code: "",
    password: "",
  });

  useEffect(() => {
    setChangeMobile(email === false && mobile === true);
    !countryCode?.country_code && dispatch(CountryCode());
  }, []);

  useEffect(() => {
    if (authData?.success) {
      dispatch(UpdateAuthData(""));
      loginDetails.sid = authData?.data?.sid;
      StateDetailsFun(loginDetails);
      verifyFun(loginDetails.otp);
      setIsLoading(false);
    } else if(!authData?.success) {
      setIsLoading(false);
    }
  }, [authData, loginDetails]);

  useEffect(() => {
    if (enableSubmit !== null) {
      const validation = Object.keys(errMsg).every((it) => errMsg[it] === "");
      if (validation) {
        setIsLoading(true);
        const payload = {
          validateType: slideChange === 2 ? "userEmail" : "userPhone",
          password: loginDetails.password,
          userDetail: slideChange === 3 ? decrptedPhone : decrptedEmail,
          newUserMail: loginDetails.email,
        };
        dispatch(ValidateUserApi(payload, getProfile?.userId));
      }
    }
  }, [enableSubmit]);

  useEffect(() => {
    setLoginDetails((prevState) => ({
      ...prevState,
      code: countryCode?.country_code?.replace("+", ""),
    }));
  }, [countryCode]);

  useEffect(() => {
    loginDetails.phcode = "+" + loginDetails.code + loginDetails.phone;
  }, [loginDetails]);

  useEffect(() => {
    setLoginDetails((prevState) => ({
      ...prevState,
      type: changeMobile ? "mobile" : "email",
    }));
  }, [changeMobile]);

  const handleValidation = () => {
    const validationParams = { ...errMsg };
    if (!changeMobile && loginDetails.email === "") {
      validationParams.email = t("Auth.emailreq");
    } else if (!changeMobile && !loginDetails.email.match(mailformat)) {
      validationParams.email = t("Auth.emailvalreq");
    } else validationParams.email = "";

    if (changeMobile && !loginDetails.phone) {
      validationParams.phone = t("Auth.phnonereq");
    } else {
      validationParams.phone = "";
    }

    if (loginDetails.password === "") {
      validationParams.password = "Field Required";
    } else {
      validationParams.password = "";
    }
    setErrmsg(validationParams);
  };

  const handleSubmit = useCallback(() => {
    handleValidation();
    setEnableSubmit(!enableSubmit);
  }, [enableSubmit, handleValidation]);

  const isFormValid = () => {
    const { email, phone, code, password } = loginDetails;
    if (changeMobile) {
      return phone && code && password;
    } else {
      return email !== "" && password;
    }
  };

  const handleChange = useCallback((data, name) => {
    setLoginDetails((prevState) => ({
      ...prevState,
      [name]: data,
    }));
  }, []);

  const handleInputChanges = (data, name) => {
    !data.includes("@") && setInputChanges(data);
    handleChange(data, name);
  };

  return (
    <>
      <div>
        {email === true && (
          <AutoComplete
            freeSolo
            Options={inputChanges ? domainOptions(inputChanges) : []}
            label={t('Settings.Email')}
            value={loginDetails.email}
            onChange={(data) => handleChange(data, "email")}
            errMsg={errMsg.email}
            onInputChange={(_, newInputValue) => handleInputChanges(newInputValue, "email")}
          />
        )}
        {/* {mobile === true && (
          <Phoneinput
            label={t("Auth.phone")}
            value={loginDetails.phone}
            onChange={(data) => handleChange(data, "phone")}
            errMsg={errMsg.phone}
            code={loginDetails.code}
            CodeChange={(data) => handleChange(data, "code")}
          />
        )} */}
        <Input
          type={newPasswordShow ? "text" : "password"}
          label={t('Settings.Password')}
          onChange={(data) => handleChange(data, "password")}
          value={loginDetails.password}
          errMsg={errMsg.password}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setNewPasswordShow(!newPasswordShow)}
                edge="end"
              >
                {newPasswordShow ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
      </div>
      <div className="setbtn">
        <Button label={t('Settings.Cancel')} onClick={() => navigate("/settings")} variant="outlined" />
        <Button
          label={t('Settings.SendOTP')}
          disabled={!isFormValid()}
          onClick={isFormValid() ? handleSubmit : () => {}}
          customStyles="auth-action-btn"
          loading={isLoading}
          loadingIndicator="Loading…"
        />
      </div>
    </>
  );
};